import { createContext } from "react";
import type { ContentfulAdventCalendarSlot } from "../../../common/types/cmsTypes";

export const AdventCalendarDoorContext = createContext<ContentfulAdventCalendarSlot | undefined>(undefined);
